import { HandySvg } from 'handy-svg';
import iconRightArrow from '../../assets/icons/svg-sprite/arrow-right.svg';

import { news } from "../../lib/api/api";
import { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import NewsCard from '../../components/newsCard/NewsCard';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

const News = () => {
    const [newsCards, setNewsCards] = useState([]);

    useEffect(() => {
        news.newsList(1, 3, 0)
            .then((res) => {
                setNewsCards(res);
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    return (
        <>
            <section className="announcements announcements--news page__announcements" id="news">
                <header className="announcements__header">
                    <div className="page-container announcements__header-container">
                        <h3 className="announcements__title title title--h2">Последние новости</h3>
                        <Link className="announcements__top-link link arrow-link arrow-link--blue" to='//telekarta.tv/news/'>Все новости
                            <HandySvg className="svg-icon arrow-link__arrow" src={iconRightArrow} width="16" height="16"/>
                        </Link>
                    </div>
                </header>
                <div className="announcements__body">
                    <Swiper
                        slidesPerView={1}
                        modules={[Pagination, Autoplay]}
                        initialSlide={1}
                        pagination={{ clickable: true }}
                        className="announcements__list"
                        autoplay={{ delay: 3000 }}
                        breakpoints={{
                            768: {
                              slidesPerView: 2
                            },
                            1230: {
                                slidesPerView: 3
                            }
                        }}
                    >
                        {newsCards.map(card => (
                            <SwiperSlide className="announcements__item">
                                <NewsCard data={card}/>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </section>
        </>
    );
};

export default News;